export default {
  'zh_CN': {
    'travel.charge-rule.id.label': 'id',
    'travel.charge-rule.id.holder': '请输入id',

    'travel.charge-rule.id.required': 'id必填',
    'travel.charge-rule.ruleName.label': '收费规则名称',
    'travel.charge-rule.ruleName.holder': '请输入收费规则名称',
    'travel.charge-rule.ruleName.max': '收费规则名称最多20个字符',

    'travel.charge-rule.ruleName.required': '收费规则名称必填',
    'travel.charge-rule.ruleCode.label': '收费规则唯一标识码',
    'travel.charge-rule.ruleCode.holder': '请输入收费规则唯一标识码',
    'travel.charge-rule.ruleCode.max': '收费规则唯一标识码最多20个字符',

    'travel.charge-rule.ruleCode.required': '收费规则唯一标识码必填',
    'travel.charge-rule.ruleType.label': '收费规则类型',
    'travel.charge-rule.ruleType.holder': '请输入收费规则类型',

    'travel.charge-rule.ruleType.dictionary': () => [{ value: 0, label: '按单位时段收费' }, {
      value: 1,
      label: '按总计时长收费'
    }, { value: 2, label: '按次收费' }, { value: 3, label: '日夜组合收费' }, { value: 4, label: '按停车时间收费' }],
    'travel.charge-rule.ruleType.required': '收费规则类型必填',
    'travel.charge-rule.ruleDetail.label': '收费规则详情',
    'travel.charge-rule.ruleDetail.holder': '请输入收费规则详情',
    'travel.charge-rule.ruleDetail.max': '收费规则详情最多4096个字符',

    'travel.charge-rule.ruleDetail.required': '收费规则详情必填',
    'travel.charge-rule.dayMaxFee.label': '按天封顶费用',
    'travel.charge-rule.dayMaxFee.holder': '请输入按天封顶费用',

    'travel.charge-rule.dayMaxFee.required': '按天封顶费用必填',
    'travel.charge-rule.dayMaxStatus.label': '按天封顶开关',
    'travel.charge-rule.dayMaxStatus.holder': '请输入按天封顶开关',

    'travel.charge-rule.dayMaxStatus.dictionary': () => [{ value: 0, label: '禁用' }, { value: 1, label: '启用' }],
    'travel.charge-rule.dayMaxStatus.required': '按天封顶开关必填',
    'travel.charge-rule.carType.label': '缴费车辆类型',
    'travel.charge-rule.carType.holder': '请输入缴费车辆类型',

    'travel.charge-rule.carType.dictionary': () => [{ value: 0, label: '不区分' }, { value: 1, label: '小型车' }, {
      value: 2,
      label: '大型车'
    }, { value: 3, label: '摩托车' }],
    'travel.charge-rule.carType.required': '缴费车辆类型必填',
    'travel.charge-rule.status.label': '状态',
    'travel.charge-rule.status.holder': '请输入状态',

    'travel.charge-rule.status.dictionary': () => [{ value: 0, label: '禁用' }, { value: 1, label: '正常' }],
    'travel.charge-rule.status.required': '状态必填',
    'travel.charge-rule.createTime.label': '创建时间',
    'travel.charge-rule.createTime.holder': '请输入创建时间',
    'travel.charge-rule.createTime.required': '创建时间必填',
    'travel.charge-rule.updateTime.label': '更新时间',
    'travel.charge-rule.updateTime.holder': '请输入更新时间',
    'travel.charge-rule.updateTime.required': '更新时间必填',
    'travel.charge-rule.isDelete.label': '是否删除',
    'travel.charge-rule.isDelete.holder': '请输入是否删除',

    'travel.charge-rule.isDelete.dictionary': () => [{ value: 0, label: '删除' }],
    'travel.charge-rule.isDelete.required': '是否删除必填'
  },
  'zh_TW': {
    'travel.charge-rule.id.label': 'id',
    'travel.charge-rule.id.holder': '請輸入id',

    'travel.charge-rule.id.required': 'id必填',
    'travel.charge-rule.ruleName.label': '收费规则名称',
    'travel.charge-rule.ruleName.holder': '請輸入收费规则名称',

    'travel.charge-rule.ruleName.required': '收费规则名称必填',
    'travel.charge-rule.ruleCode.label': '收费规则唯一标识码',
    'travel.charge-rule.ruleCode.holder': '請輸入收费规则唯一标识码',

    'travel.charge-rule.ruleCode.required': '收费规则唯一标识码必填',
    'travel.charge-rule.ruleType.label': '收费规则类型',
    'travel.charge-rule.ruleType.holder': '請輸入收费规则类型',

    'travel.charge-rule.ruleType.required': '收费规则类型必填',
    'travel.charge-rule.ruleDetail.label': '收费规则详情',
    'travel.charge-rule.ruleDetail.holder': '請輸入收费规则详情',

    'travel.charge-rule.ruleDetail.required': '收费规则详情必填',
    'travel.charge-rule.dayMaxFee.label': '按天封顶费用',
    'travel.charge-rule.dayMaxFee.holder': '請輸入按天封顶费用',

    'travel.charge-rule.dayMaxFee.required': '按天封顶费用必填',
    'travel.charge-rule.dayMaxStatus.label': '按天封顶开关',
    'travel.charge-rule.dayMaxStatus.holder': '請輸入按天封顶开关',

    'travel.charge-rule.dayMaxStatus.required': '按天封顶开关必填',
    'travel.charge-rule.carType.label': '缴费车辆类型',
    'travel.charge-rule.carType.holder': '請輸入缴费车辆类型',

    'travel.charge-rule.carType.required': '缴费车辆类型必填',
    'travel.charge-rule.status.label': '状态',
    'travel.charge-rule.status.holder': '請輸入状态',

    'travel.charge-rule.status.required': '状态必填',
    'travel.charge-rule.createTime.label': '创建时间',
    'travel.charge-rule.createTime.holder': '請輸入创建时间',

    'travel.charge-rule.createTime.required': '创建时间必填',
    'travel.charge-rule.updateTime.label': '更新时间',
    'travel.charge-rule.updateTime.holder': '請輸入更新时间',

    'travel.charge-rule.updateTime.required': '更新时间必填',
    'travel.charge-rule.isDelete.label': '是否删除',
    'travel.charge-rule.isDelete.holder': '請輸入是否删除',

    'travel.charge-rule.isDelete.required': '是否删除必填'
  },
  'en_US': {
    'travel.charge-rule.id.label': 'id',
    'travel.charge-rule.id.holder': 'Enter id',
    'travel.charge-rule.id.max': 'id max length: id',

    'travel.charge-rule.id.required': 'id required',
    'travel.charge-rule.ruleName.label': 'ruleName',
    'travel.charge-rule.ruleName.holder': 'Enter ruleName',
    'travel.charge-rule.ruleName.max': 'ruleName max length: 收费规则名称',

    'travel.charge-rule.ruleName.required': 'ruleName required',
    'travel.charge-rule.ruleCode.label': 'ruleCode',
    'travel.charge-rule.ruleCode.holder': 'Enter ruleCode',
    'travel.charge-rule.ruleCode.max': 'ruleCode max length: 收费规则唯一标识码',

    'travel.charge-rule.ruleCode.required': 'ruleCode required',
    'travel.charge-rule.ruleType.label': 'ruleType',
    'travel.charge-rule.ruleType.holder': 'Enter ruleType',
    'travel.charge-rule.ruleType.max': 'ruleType max length: 收费规则类型',

    'travel.charge-rule.ruleType.required': 'ruleType required',
    'travel.charge-rule.ruleDetail.label': 'ruleDetail',
    'travel.charge-rule.ruleDetail.holder': 'Enter ruleDetail',
    'travel.charge-rule.ruleDetail.max': 'ruleDetail max length: 收费规则详情',

    'travel.charge-rule.ruleDetail.required': 'ruleDetail required',
    'travel.charge-rule.dayMaxFee.label': 'dayMaxFee',
    'travel.charge-rule.dayMaxFee.holder': 'Enter dayMaxFee',
    'travel.charge-rule.dayMaxFee.max': 'dayMaxFee max length: 按天封顶费用',

    'travel.charge-rule.dayMaxFee.required': 'dayMaxFee required',
    'travel.charge-rule.dayMaxStatus.label': 'dayMaxStatus',
    'travel.charge-rule.dayMaxStatus.holder': 'Enter dayMaxStatus',
    'travel.charge-rule.dayMaxStatus.max': 'dayMaxStatus max length: 按天封顶开关',

    'travel.charge-rule.dayMaxStatus.required': 'dayMaxStatus required',
    'travel.charge-rule.carType.label': 'carType',
    'travel.charge-rule.carType.holder': 'Enter carType',
    'travel.charge-rule.carType.max': 'carType max length: 缴费车辆类型',

    'travel.charge-rule.carType.required': 'carType required',
    'travel.charge-rule.status.label': 'status',
    'travel.charge-rule.status.holder': 'Enter status',
    'travel.charge-rule.status.max': 'status max length: 状态',

    'travel.charge-rule.status.required': 'status required',
    'travel.charge-rule.createTime.label': 'createTime',
    'travel.charge-rule.createTime.holder': 'Enter createTime',
    'travel.charge-rule.createTime.max': 'createTime max length: 创建时间',

    'travel.charge-rule.createTime.required': 'createTime required',
    'travel.charge-rule.updateTime.label': 'updateTime',
    'travel.charge-rule.updateTime.holder': 'Enter updateTime',
    'travel.charge-rule.updateTime.max': 'updateTime max length: 更新时间',

    'travel.charge-rule.updateTime.required': 'updateTime required',
    'travel.charge-rule.isDelete.label': 'isDelete',
    'travel.charge-rule.isDelete.holder': 'Enter isDelete',
    'travel.charge-rule.isDelete.max': 'isDelete max length: 是否删除',

    'travel.charge-rule.isDelete.required': 'isDelete required'
  }
}
